import { render, staticRenderFns } from "./CodigosHabilidadesForm.vue?vue&type=template&id=86ec9402"
import script from "./CodigosHabilidadesForm.vue?vue&type=script&lang=js"
export * from "./CodigosHabilidadesForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports